if (!customElements.get('slideshow-component-swiper')) {
    customElements.define('slideshow-component-swiper', class SlideshowComponentSwiper extends HTMLElement {
        constructor() {
            super();
            this.wlSwiper = null;
            this.auto_play_time = Number(this.getAttribute('data-auto-play-time')) || 3000;
        }

        connectedCallback() {
            setTimeout(() => this.initializeSwiper(), 50);
        }
        
        initializeSwiper() {
            const totalSlides = this.querySelectorAll('.swiper-slide').length / 2;
            const initialSlideIndex = totalSlides;
            this.wlSwiper = new Swiper(this, {
                enabled: true,
                loop: true,
                loopAdditionalSlides: 1,
                autoplay: {
                    disableOnInteraction: false
                },
                slidesPerView: 1,
                spaceBetween: 25,
                centeredSlides: true,
                initialSlide: initialSlideIndex,
                speed: 300, // スライドの切り替え速度を短縮
                preloadImages: false, // 画像の読み込みを待たずに開始
                lazy: true, // 遅延読み込みを有効化
                keyboard: { enabled: true },
                grabCursor: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.slideshow-v2__swiper-button-next',
                    prevEl: '.slideshow-v2__swiper-button-prev'
                },
                observer: true,
                observeParents: true,
                runCallbacksOnInit: true, 
                on: {
                    afterInit: function() {
                        this.params.autoplay.delay = this.el.getAttribute('data-auto-play-time') || 3000;
                        this.autoplay.start();
                    },
                    transitionEnd: function(){
                        let offer = this.el.querySelector('.slideshow-v2__number-slides');
                        if(this.el.querySelector('.swiper-slide-active') != null){
                            let slide_active = this.el.querySelector('.swiper-slide-active');
                            let index = Number(slide_active.getAttribute('data-swiper-slide-index'));
                            let total = this.slides.length / 2;
                            let index_slide = index + 1;
                            if (index_slide > total) {
                                index_slide = index_slide - total;
                            }
                            offer.innerHTML = `0${index_slide} / 0${total}`;
                        }
                    }
                }
            });
        }
    });
}
